import { render, staticRenderFns } from "./reportOweFeeDetailList.vue?vue&type=template&id=65a2cc6f&scoped=true"
import script from "./reportOweFeeDetailList.vue?vue&type=script&lang=js"
export * from "./reportOweFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./reportOweFeeDetailList.vue?vue&type=style&index=0&id=65a2cc6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2cc6f",
  null
  
)

export default component.exports